'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      defaultSrc: require('@/static/images/test.jpg'),
      isShow: false,
      isFull: true,
      initX: 24,
      initY: window.screen.height - 560,
      content: ''
    };
  },
  created: function created() {
    document.addEventListener('mouseup', this.changeDown);
  },
  mounted: function mounted() {},

  computed: {
    initPosition: function initPosition() {
      return {
        left: this.initX,
        top: this.initY
      };
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('mouseup', this.changeDown);
  },

  methods: {
    changeFull: function changeFull() {
      this.isFull = !this.isFull;
    },
    mousedown: function mousedown(e) {
      this.down = true;
      this.offsetX = e.offsetX;
      this.offsetY = e.offsetY;
    },
    mousemove: function mousemove(e) {
      if (!this.down) return;
      this.initX = e.clientX - this.offsetX + 'px';
      this.initY = e.clientY - this.offsetY + 'px';
    },
    mouseup: function mouseup() {
      this.changeDown();
    },
    changeDown: function changeDown() {
      this.down = false;
    }
  }
};